import React from "react";
import { SharedMarketPlaceSummaries } from "@app/shared";

const MarketPlaceSummaryList: React.FC = () => {
  return <SharedMarketPlaceSummaries />;
};

export default MarketPlaceSummaryList;
